import { Pipe, PipeTransform } from "@angular/core";
import { DateService } from "../service/date.service";

@Pipe({
  name: "dateformat",
})
export class DateFormatPipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  /**
   * @params args: Array<string> || string
   * @example
   *    transform(['YMD', 'hms']) 根据系统设置格式时间 Y年 M月 D日  h时 m分 s秒
   *    transform(['YMD']) 只显示日期，不显示时间
   *    transform(['MD']) 只展示月和日
   *    transform(['YM']) 只展示年和月
   *    transform(['YM', 'hm']) 展示年月与时分
   *
   *    transform('YYYY-MM-DD')   自定义格式时间
   */
  transform(value?: any, args?): any {
    if (value === null || value === undefined) {
      return value;
    }
    // if (!this.international.isInternational()) {
    //   return value;
    // }

    return this.dateService.format(value, args);
  }
}
